import { IFetchDataState, IPagination } from '@interfaces/common';
import { IInquiryDetails } from '@interfaces/inquiries';

export interface IInquiriesStateChunk extends IFetchDataState {
  data: IInquiryDetails[];
  pagination: Partial<IPagination>;
}

export enum TInquiriesListKey {
  InProgress = 'inProgress',
  Complete = 'complete',
}

export type IInquiriesState = Record<TInquiriesListKey, IInquiriesStateChunk>;
